import React, { useContext } from "react";
import { ConfirmDialog, useNotifications } from "sprint-common-web";

import { OrderRequestStatus } from "../../../../../common/types/OrderRequestStatus";
import { useOrdersModuleApi } from "../../../../common/useOrdersModuleApi";
import { OrderRequestListingContext } from "../../context/OrderRequestListingContext";
import { OrderRequestListingItem } from "../../OrderRequestListingItem";

export type SendOrderRequestToCloudDialogProps = {
    item: OrderRequestListingItem;
    isOpen: boolean;
    onClose(): void;
};

export const SendOrderRequestToCloudDialog: React.VFC<SendOrderRequestToCloudDialogProps> = ({
    item,
    isOpen,
    onClose
}: SendOrderRequestToCloudDialogProps) => {
    const { createCloudOrderFromRequest } = useOrdersModuleApi();
    const { updateOrderRequest } = useContext(OrderRequestListingContext);
    const { success } = useNotifications();

    const sendToCloud = async () => {
        await createCloudOrderFromRequest({ orderRequestId: item.id });

        success("Order request sent to cloud successfully");

        updateOrderRequest({ id: item.id, status: OrderRequestStatus.CloudProcessing });
        onClose();
    };

    return (
        <ConfirmDialog
            title="Send order request to cloud"
            text="Are you sure you want to send this order request to cloud? This action is irreversible."
            hidden={!isOpen}
            confirm={{ onClick: sendToCloud }}
            cancel={{ onClick: onClose }}
        />
    );
};
